"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledArticleList = exports.StyledPillOptionsList = exports.StyledList = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = require("../../utils/colors");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  list-style: none;\n  padding: 1rem 1rem;\n  display: block;\n  width: ", ";\n  margin-top: 1rem;\n  margin-bottom: 0;\n  background: ", ";\n  border: none;\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  list-style: none;\n  padding: 1rem 1rem;\n  display: block;\n  width: ", ";\n  max-width: 340px;\n  border-radius: 10px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  margin-top: 1rem;\n  margin-bottom: 0;\n  overflow: auto;\n  background: ", ";\n  border: 1px solid ", ";\n\n  @media screen and (max-width: ", ") {\n    margin: 0;\n    border-radius: unset;\n    height: 100vh;\n    width: 100vw;\n    max-width: unset;\n  }\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  margin: 0;\n  padding: 0;\n  width: ", ";\n  list-style: none;\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n  border-bottom-left-radius: ", ";\n  border-bottom-right-radius: ", ";\n  border-top: ", ";\n  border-left: ", ";\n  border-right: ", ";\n  border-bottom: ", ";\n  overflow: hidden;\n  box-sizing: border-box;\n  background: ", ";\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var disabledStyle = function disabledStyle(props) {
  return (0, _styledComponents.css)(_templateObject(), props.disabled && "opacity: 0.3;");
};

var StyledList = _styledComponents.default.ul(_templateObject2(), function (props) {
  return props.width;
}, function (props) {
  return props.theme.list.border.radius || props.theme.list.border.topLeftRadius;
}, function (props) {
  return props.theme.list.border.radius || props.theme.list.border.topRightRadius;
}, function (props) {
  return props.theme.list.border.radius || props.theme.list.border.bottomLeftRadius;
}, function (props) {
  return props.theme.list.border.radius || props.theme.list.border.bottomRightRadius;
}, function (props) {
  return "".concat(props.theme.list.border.top, " ").concat(props.theme.list.border.style, " ").concat((0, _colors.normaliseColor)(props.theme.list.border.color, props.theme));
}, function (props) {
  return "".concat(props.theme.list.border.left, " ").concat(props.theme.list.border.style, " ").concat((0, _colors.normaliseColor)(props.theme.list.border.color, props.theme));
}, function (props) {
  return "".concat(props.theme.list.border.right, " ").concat(props.theme.list.border.style, " ").concat((0, _colors.normaliseColor)(props.theme.list.border.color, props.theme));
}, function (props) {
  return "".concat(props.theme.list.border.bottom, " ").concat(props.theme.list.border.style, " ").concat((0, _colors.normaliseColor)(props.theme.list.border.color, props.theme));
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.list.background.color, props.theme);
}, function (props) {
  return props.disabled && disabledStyle(props);
});

exports.StyledList = StyledList;

var StyledPillOptionsList = _styledComponents.default.ul(_templateObject3(), function (props) {
  return props.width;
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.list.background.color, props.theme);
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.list.border.color, props.theme);
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.sm;
}, function (props) {
  return props.disabled && disabledStyle(props);
});

exports.StyledPillOptionsList = StyledPillOptionsList;

var StyledArticleList = _styledComponents.default.ul(_templateObject4(), function (props) {
  return props.width;
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.list.background.color, props.theme);
}, function (props) {
  return props.disabled && disabledStyle(props);
});

exports.StyledArticleList = StyledArticleList;